import util, { getComponentFromPageBar, getElementScale, getSvgPath } from "../util";
import Matrix from "./matrix";
import History from "./history";
import Cached from "./cached";
import { deselectAll, select } from "./selection";
import $ from "jquery";
import constants from "../constants";
import store from "../store";
import MenuObject, { setInitColors } from "./menu-object";
import { getJumpTextSelection, setJumpTextSelection } from "./jump-text";
import { removeSnapGuides, showSnapGuides } from "./snap-guides";
import { updateElementPercentPosition } from "./position";
import { convertFramePosToPx, alignFramePreview } from "./reposition-frame";
import designService from "../service/designService";
import designDomain from "../domain/designDomain";
import * as actions from "../actions";
import { adjustColor, adjustFontSize, updateActiveFonts } from "./font";
import { moveToBack } from "./layer";
import { markAsModified } from "./mark-as-modified";
import Renderer, { fixQRRatio } from '../canvas/renderer';
import { getTextTemplate } from "./text-templates";
import Cleaner from './cleaner';
import { getRotationDegrees } from "./alignment";
import { updatePageBars, removePageBars } from "./selection";
import imageService from "../service/imageService";
import { handlePixabayUpload, handlePixabayVideoUpload } from "./pixabay-upload";
import Interactable from "./interactable";

function shouldMove($target) {
    if (store.getState().isMobileVersion) return true;
    if (getJumpTextSelection()) return true;
    const hasEditable = !!Cached.getEditable() && Cached.getEditable().length > 0;

    if (hasEditable) {
        const $mv = Cached.getEditable().parents('.move');
        if (!!$target[0] && (Cached.getEditable()[0] === $target[0] || (!!$mv && $mv[0] === $target[0]))) {
            return false;
        }
    }
    return true;
}

function moveToPage($target, $page, isUndo) {
    let elTop = $target.offset().top;
    const pgTop = $page.offset().top;
    if (elTop > 0) {
        elTop -= pgTop;
    } else {
        const $parent = $target.parents('.page');
        const prTop = $parent.position().top;
        elTop = prTop + elTop;
        elTop += -pgTop;
    }
    $page.children('.content').append($target);

    const id = $target.attr('id');
    let $prevBars = $(`.page .page-bars #${id}`);
    if ($prevBars.length > 0) {
        let $clone = $prevBars.clone();
        $prevBars.remove();
        $page.find('.page-bars').append($clone);
    }

    const zoomfactor = store.getState().zoom / 100;
    elTop = elTop / zoomfactor;

    if (!isUndo) $target.css('top', `${util.pixelToPercent(elTop, util.getActiveDimensions().height)}%`);

    Matrix.update($target.attr('id'), { top: elTop, page: $page.attr('id') });
}

export function onComponentManualMove($element, position) {
    if (!$element || $element.length === 0) return false;

    const $group = $element.parents('.group');
    if ($group.length > 0) {
        $element = $group;
    }

    let oldLeft = parseFloat($element.get(0).style.left);
    let oldTop = parseFloat($element.get(0).style.top);
    const isPercentTop = $element.get(0).style.top.indexOf('%') > -1;
    const isPercentLeft = $element.get(0).style.left.indexOf('%') > -1;

    if (!isPercentTop) {
        oldTop = util.pixelToPercent(oldTop, util.getActiveDimensions().height);
    }
    if (!isPercentLeft) {
        oldLeft = util.pixelToPercent(oldLeft, util.getActiveDimensions().width);
    }

    const left = position.left ? oldLeft + util.pixelToPercent(position.left, util.getActiveDimensions().width) : oldLeft;
    const top = position.top ? oldTop + util.pixelToPercent(position.top, util.getActiveDimensions().height) : oldTop;

    function doAction(left, top, undo) {
        $element.css('left', `${left}%`);
        $element.css('top', `${top}%`);

        if (isElementOffPage($element)) {
            Cleaner.removeElement($element);
            store.dispatch(actions.deselect());
            return;
        }

        Matrix.update($element.attr('id'), {
            left,
            top,
        })
        // console.log(Matrix.toString());

        Interactable.refreshControls();
        updatePageBars($element);
    }

    const undo = () => doAction(oldLeft, oldTop);
    const redo = () => doAction(left, top, undo);

    redo();

    History.push(undo, redo, 'Manual Move');

    return true;
}

let INITIAL_SCROLL_TOP = 0;
export function onComponentMoveStart($target, event, reposition = false) {
    $target = getComponentFromPageBar($target);
    const isMobile = store.getState().isMobileVersion;
    if (isMobile && !$target.hasClass('in-focus')) {
        return;
    }

    $('body').addClass('cmp-move');
    Cached.isComponentMoveInProgress = true;

    const $group = $target.parents('.group');
    if ($group.length > 0) $target = $group;

    if (!$target.hasClass('in-focus')) {
        deselectAll();
        select($target, true);
    }

    const left = $target.css('left');
    const top = $target.css('top');

    $target.attr('data-x', parseFloat(left));
    $target.attr('data-y', parseFloat(top));

    if ($target.get(0).style.width === '') {
        $target.data('width-auto', true);
    }

    $target.attr('data-original-left', parseFloat(left));
    $target.attr('data-original-top', parseFloat(top));

    $target.attr('data-original-width', `${util.pixelToPercent($target.width(), util.getActiveDimensions().width)}%`);
    $target.attr('data-original-height', `${util.pixelToPercent($target.height(), util.getActiveDimensions().height)}%`);

    $target.attr('data-original-page', $target.parents('.page').attr('id'));
    $target.attr('data-original-page-z-index', $target.parents('.page').css('z-index'));
    $target.attr('data-original-transform', $target.css('transform'));

    if (reposition) {
        let frame = null;
        $target.parent().find('[data-component="frame"').each(function () {
            if ($(this).attr('id') === $target.attr('id')) {
                frame = $(this);
            }
        })
        frame.attr('data-original-bg-css', frame.find('.img').css('background'));
    }

    if (util.isSafari()) {
        //$('body').css('overflow', 'hidden');
        INITIAL_SCROLL_TOP = $(window).scrollTop();
    }
}

export function onComponentMove($target, event, reposition = false) {
    $target = getComponentFromPageBar($target);
    const isMobile = store.getState().isMobileVersion;
    if (isMobile && !$target.hasClass('in-focus')) return;

    const $window = $(window);
    const $group = $target.parents('.group');
    if ($group.length > 0) $target = $group;

    if (!shouldMove($target, event)) return;

    if (util.isSafari() && $window.scrollTop() !== INITIAL_SCROLL_TOP) {
        $window.scrollTop(INITIAL_SCROLL_TOP);
    }

    let left = (parseFloat($target.attr('data-x')) || 0) + event.dx;
    let top = (parseFloat($target.attr('data-y')) || 0) + event.dy;

    if (constants.SCALED_ZOOM_APPROACH) {
        const zoom = store.getState().zoom / 100;
        left = (parseFloat($target.attr('data-x')) || 0) + event.dx / zoom;
        top = (parseFloat($target.attr('data-y')) || 0) + event.dy / zoom;
    }

    //if (!reposition) showSnapGuides($target, top, left);

    $target.css('transform', 'none');

    const fixedTop = $target.offset().top - $window.scrollTop() + event.dy;
    const fixedLeft = $target.offset().left - $window.scrollLeft() + event.dx;

    $target.css('transform', $target.attr('data-original-transform'));

    const width = $target.width();
    const height = $target.height();

    $target.parents('.page').css('z-index', parseInt($target.attr('data-original-page-z-index'), 10) + 2);

    let $frame = null;

    if (constants.SCALED_ZOOM_APPROACH) {
        $target.css('z-index', '9999');

        if (reposition) {
            $target.parent().find('[data-component="frame"').each(function () {
                if ($(this).attr('id') === $target.attr('id')) {
                    $frame = $(this);
                }
            })
            const $frameImg = $frame.find('.img');
            const borderWidth = $target.find('img').attr('data-border-width') ? parseFloat($target.find('img').attr('data-border-width')) : 0;
            let originalX = $frameImg.css('background-position-x');
            let originalY = $frameImg.css('background-position-y');
            if (originalX === '50%' || originalY === '50%') {
                let converted = convertFramePosToPx($target, $frameImg);
                originalX = converted[0];
                originalY = converted[1];
            }
            let originalSize = $frameImg.css('background-size');
            if (originalSize === 'cover') {
                $frameImg.css('background-size', width + 'px ' + height + 'px');
            }

            const rotation = getRotationDegrees($target) * (Math.PI / 180);

            let newX = 0;
            let newY = 0;
            if (constants.SCALED_ZOOM_APPROACH) {
                const zoom = store.getState().zoom / 100;
                let deltaX = event.dx / zoom;
                let deltaY = event.dy / zoom;

                const flippedX = $target.find('img').attr('flipped-x') === "true";
                const flippedY = $target.find('img').attr('flipped-y') === "true";
                newX = flippedX ? parseFloat(originalX) - (Math.cos(rotation) * deltaX + Math.sin(rotation) * deltaY) :
                    parseFloat(originalX) + (Math.cos(rotation) * deltaX + Math.sin(rotation) * deltaY);
                newY = flippedY ? parseFloat(originalY) + (Math.sin(rotation) * deltaX - Math.cos(rotation) * deltaY) :
                    parseFloat(originalY) - (Math.sin(rotation) * deltaX - Math.cos(rotation) * deltaY);

                if (newX > 0) {
                    newX = 0;
                }
                if (newY > 0) {
                    newY = 0;
                }
                if (newX < $frame.width() - width - 2 * borderWidth) {
                    newX = $frame.width() - width - 2 * borderWidth;
                }
                if (newY < $frame.height() - height - 2 * borderWidth) {
                    newY = $frame.height() - height - 2 * borderWidth;
                }
            }

            $frameImg.css('background-position-x', newX + 'px');
            $frameImg.css('background-position-y', newY + 'px');
        }

        if (reposition) {
            alignFramePreview($target, $frame);
        } else {
            $target.css('top', top);
            $target.css('left', left);
        }

    } else {
        $target.css('position', 'fixed');
        $target.css('z-index', '9999');
        $target.css('top', fixedTop);
        $target.css('left', fixedLeft);

        $target.css('width', Math.round(width));
        $target.css('height', $target[0].style.height ? height : '');
    }

    $target.attr('data-y', top);
    $target.attr('data-x', left);

    updatePageBars($target);
}

function getDropElement(event) {
    const $drop = $(event._interaction.dropState.cur.element);
    return $drop;
}

export function onComponentDropped($target, event, reposition = false) {
    $target = getComponentFromPageBar($target);
    const isMobile = store.getState().isMobileVersion;

    $('body').removeClass('cmp-move');
    Cached.isComponentMoveInProgress = false;

    const $group = $target.parents('.group');
    if ($group.length > 0) $target = $group;

    let repositionedFrame = null;
    if (reposition) {
        $target.parent().find('[data-component="frame"').each(function () {
            if ($(this).attr('id') === $target.attr('id')) {
                repositionedFrame = $(this);
            }
        })
    }

    if (store.getState().$elements.length === 1) {
        if (!shouldMove($target, event)) {
            if (util.isSafari()) {
                //$('body').css('overflow', 'auto');
            }
            return;
        }
    }

    let left = parseFloat($target.attr('data-x')) || 0;
    let top = parseFloat($target.attr('data-y')) || 0;
    let $drop = getDropElement(event);
    if ($drop.length !== 0) {
        $drop = util.getPositionPage($target);
    }

    if (!reposition) removeSnapGuides();

    $target.parents('.page').css('z-index', $target.attr('data-original-page-z-index'));
    $target.css('position', 'absolute');
    $target.css('z-index', '');

    const isMenuObject = MenuObject.isMenuObject($target);
    if (!isMenuObject) {
        $target.css('width', $target[0].style.width ? $target.attr('data-original-width') : '');
    }

    if ($target.data('width-auto')) {
        $target.removeData('width-auto');
        $target[0].style.width = '';
    }

    if (!isMenuObject) {
        $target.css('height', $target[0].style.height ? $target.attr('data-original-height') : '');
    }

    $target.css('max-width', '');

    $target.removeAttr('data-width');
    $target.removeAttr('data-height');
    $target.removeAttr('data-x');
    $target.removeAttr('data-y');

    const doAction = (top, left, zoomState, $drop, target, bgCss, undo) => {
        //updateElementPercentPosition(target, top, left, zoomState.pageWidth, zoomState.pageHeight);

        if (!$drop) {
            undo();
            return;
        }
        if (util.isPage($drop)) {
            const $dropParent = $drop;
            const $parent = target.parents('.page');
            if ($parent.length > 0) {
                const $targetPage = util.getPositionPage(target);

                if ($dropParent.attr('id') !== $parent.attr('id')) {
                    if (store.getState().$elements.length === 1) {
                        moveToPage(target, $dropParent, !undo);
                    } else {
                        if ($targetPage) {
                            if ($targetPage.attr('id') !== $parent.attr('id')) {
                                moveToPage(target, $dropParent, !undo);
                            }
                        } else {
                            undo();
                        }
                    }
                }
            }
        } else if (util.isFrame($drop)) {
            const $targetPage = util.getPositionPage(target);
            const $parent = target.parents('.page');

            if (!$targetPage) {
                const $dropPage = util.getPositionPage($drop.get(0));

                if ($dropPage && $dropPage.attr('id') === target.parents('.page').attr('id')) {
                    const $dropParent = util.isPage($drop) ? $drop : $drop.parents('.page');

                    if ($dropParent.attr('id') !== $parent.attr('id')) {
                        moveToPage(target, $dropParent, !undo);
                    }
                } else {
                    moveToPage(target, $drop.parents('.page'), !undo);
                }
            } else if ($targetPage.attr('id') !== $parent.attr('id')) {
                moveToPage(target, $targetPage, !undo);
            }
        } else {
            // undo();
            if (isElementOffPage($target)) {
                Cleaner.removeElement($target);
                store.dispatch(actions.deselect());
                store.dispatch(actions.multiDeselect($target));
                deselectAll();
                $('body').click()
                return;
            }
        }

        Matrix.update(target.attr('id'), { left, top });
        updatePageBars($target);

        if (reposition) {
            repositionedFrame.find('.img').css('background', bgCss);
            alignFramePreview($target, repositionedFrame);
        }

        if (util.isFirefox()) {
            $target.click();
        }

        if (isElementOffPage($target)) {
            Cleaner.removeElement($target);
            store.dispatch(actions.deselect());
            store.dispatch(actions.multiDeselect($target));
            deselectAll();
            $('body').click()
            return;
        }
    };

    const $oldPage = $target.parents('.page');
    const oldLeft = $target.attr('data-original-left');
    const oldTop = $target.attr('data-original-top');

    const zoom = store.getState().zoom;
    const pageWidth = util.getActiveDimensions().width;
    const pageHeight = util.getActiveDimensions().height;

    let bgCss = null;
    let originalBgCss = null;
    if (reposition) {
        bgCss = repositionedFrame.find('.img').css('background');
        originalBgCss = repositionedFrame.attr('data-original-bg-css');
    }

    const getZoomState = () => {
        return {
            'zoom': zoom,
            'pageWidth': pageWidth,
            'pageHeight': pageHeight
        }
    };

    if (isMobile && !$target.hasClass('in-focus')) {
        return;
    }

    /*if (isMobile) {
        select($target, false);
        $target.trigger('click');
    }*/

    const undo = () => doAction(oldTop, oldLeft, getZoomState(), $oldPage, $target, originalBgCss);
    const redo = () => doAction(top, left, getZoomState(), $drop, $target, bgCss, undo);

    redo();
    History.push(undo, redo, 'Move');

    setJumpTextSelection(false);

    if (util.isSafari()) {
        //$('body').css('overflow', 'auto');
    }
}

export const CENTER = 'center';
export const VIEWPORT_CENTER = 'viewport-center';
const isRelativeDimension = (top, left) => top === CENTER || left === CENTER || top === VIEWPORT_CENTER || left === VIEWPORT_CENTER;

function setComponentInitialPosition($page, $comp, top, left) {
    const $window = $(window);
    const scrollTop = $window.scrollTop();
    const pageTop = $page.offset().top;

    let pageWidth = $page.width();
    //let pageHeight = $page.get(0).getBoundingClientRect().height;
    let pageHeight = $page.height();

    if (isRelativeDimension(top, left)) {
        $comp.css('opacity', 0);

        const isTopCenter = top === CENTER;
        const isLeftCenter = left === CENTER;
        const isTopViewportCenter = top === VIEWPORT_CENTER;
        const isLeftViewportCenter = top === VIEWPORT_CENTER;

        if (top === CENTER || top === VIEWPORT_CENTER) top = pageHeight / 2;
        if (left === CENTER || left === VIEWPORT_CENTER) left = pageWidth / 2;

        const zoom = store.getState().zoom / 100;
        if (constants.SCALED_ZOOM_APPROACH && zoom > 2) {
            top = top / zoom;
            pageWidth = pageWidth * zoom;
            pageHeight = pageHeight * zoom;
        }

        util.nextTick(() => {

            let componentBox = $comp.get(0).getBoundingClientRect();

            let { top } = $comp.position();

            if (constants.SCALED_ZOOM_APPROACH && zoom > 2) {
                top = top / zoom;
            }
            if (isTopCenter) {
                top = `${util.pixelToPercent(top - (componentBox.height / 2), pageHeight)}%`;
            } else if (isTopViewportCenter) {
                const pageBottomLimit = pageTop + pageHeight;
                const portBottomLimit = scrollTop + $window.height();
                const bottomLimit = pageBottomLimit < portBottomLimit ? pageBottomLimit : portBottomLimit;
                const topLimit = scrollTop > pageTop ? scrollTop : pageTop;
                const visible = bottomLimit - topLimit;
                const topStart = scrollTop > pageTop ? scrollTop - pageTop : 0;
                top = topStart + (visible / 2);
                top = `${util.pixelToPercent(top - (componentBox.height / 2), pageHeight)}%`;
            }

            let { left } = $comp.position();
            if (isLeftCenter) {
                left = `${util.pixelToPercent(left - ($comp.width() / 2), pageWidth)}%`;
            } else if (isLeftViewportCenter) {
                left = `${util.pixelToPercent(left - ($comp.width() / 2), pageWidth)}%`;
            }

            $comp.css('left', left);
            $comp.css('top', top);
            $comp.attr('data-x', left);
            $comp.attr('data-y', top);

            $comp.css('opacity', '');
        });
    }

    top = scrollTop - pageTop > 0 ? scrollTop - pageTop + top + 80 : top;

    $comp.css('left', `${util.pixelToPercent(left, pageWidth)}%`);
    $comp.css('top', `${util.pixelToPercent(top, pageHeight)}%`);
    $comp.attr('data-x', left);
    $comp.attr('data-y', top);

    return { top, left };
}

export function addComponent(parentId, html, config = {}) {
    markAsModified();

    if (config.textPreset) {
        html = getTextTemplate(config.textPreset);
    }

    let $comp = $(html);
    const isImage = $comp.hasClass('image');
    const isVideoFrame = $comp.hasClass('video');
    const isShape = util.isShape($comp);
    const isIllustration = util.isIllustration($comp);
    const isGroup = $comp.hasClass('group');
    const isFrame = util.isFrame($comp);
    const isText = util.isText($comp);
    const isBackground = util.isBackground($comp);
    const isQrCode = $comp.hasClass('qr');
    const isMenuObj = MenuObject.isMenuObject($comp);
    const componentId = util.UUID.get();

    const $parent = $(`#${parentId}`);
    const $page = util.isPage($parent) ? $parent : $parent.parents('.page');
    let type = 'text';

    $comp.find('.actions').remove();
    $comp.find('.author-info').remove();
    $comp.find('.video-info').remove();
    $comp.find('.favorite-button').remove();

    if (config.isFromTemplate) {
        const styles = config.styles || {};
        Object.entries(styles).forEach(([key, val]) => {
            $comp.css(key, val);
        });

        if (!isGroup) {
            $comp.addClass('select');
            const $texts = $comp.find('[data-component=text]');
            $texts.each(function () { adjustFontSize($(this)) });
        }

        $comp.attr('id', componentId);
        $comp.addClass('move');
        $comp.css('position', 'absolute');
        if (isText) $comp.css('width', 'max-content');

        let { top, left } = setComponentInitialPosition($page, $comp, config.position.top, config.position.left);
        config.position.top = top;
        config.position.left = left;

        let useSmartColor = $comp.attr('sample-text') !== "true";

        // color (in decimal) above which text should be light
        const smartColorThreshold = 8388607;
        // default colors
        const lightFont = '#fff';
        const darkFont = '#000';

        let fontColor = '';

        // find fill color if there is a filled shape visible at specific percent coordinates
        function findShapeOverlap(x, y) {
            let overlapColor = '';
            [].reverse.call($page.find('.content').children('[data-component="shape"]')).each(function () {
                const $this = $(this);
                let fillColor = getSvgPath($this.children('.svg-content')).attr('fill');
                if (fillColor && fillColor != 'none') {
                    let shapeTop = parseFloat($this.css('top'));
                    let shapeBottom = shapeTop + parseFloat($this.css('height'));
                    let shapeLeft = parseFloat($this.css('left'));
                    let shapeRight = shapeLeft + parseFloat($this.css('width'));

                    if (shapeLeft < x && shapeRight > x && shapeTop < y && shapeBottom > y) {
                        overlapColor = fillColor.startsWith('rgb') ? util.rgb2hex(fillColor).substring(1, 7) : fillColor.substring(1, 7);
                        return false;
                    }
                }
            });
            return overlapColor;
        }

        // this is checking if a shape is present where you want to place the text/menuobj and adjusting the color accordingly
        if (isMenuObj || isText && useSmartColor) {
            let frame = $page.find('[data-component="frame"][data-full-page]');
            if (frame.length && frame.attr('primary-color')) {
                fontColor = parseInt(frame.attr('primary-color'), 16) > smartColorThreshold ? darkFont : lightFont;
            } else {
                fontColor = parseInt(util.rgb2hex($page.css('background-color')).substring(1, 7), 16) > smartColorThreshold ? darkFont : lightFont;
            }
        }
        if (isMenuObj) {
            MenuObject.refreshStyles($comp);
            MenuObject.ensureIds($comp);

            setTimeout(() => {
                $comp.css('width', '45%');

                let x = parseFloat($comp.css('left')) + parseFloat($comp.css('width')) / 2;
                let y = parseFloat($comp.css('top'));

                let shapeOverlapColor = findShapeOverlap(x, y);
                if (shapeOverlapColor !== '') {
                    fontColor = parseInt(shapeOverlapColor, 16) > smartColorThreshold ?
                        darkFont : lightFont;
                }

                if (!config.keepColors) {
                    setInitColors($comp, fontColor);
                }
            });
        } else if (isText) {
            const isSampleText = $comp.attr('sample-text') === 'true';
            if (isSampleText) {
                $comp.css('visibility', 'hidden');
            } else {
                adjustFontSize($comp);
            }

            setTimeout(() => {
                if (isSampleText) {
                    $comp.css('left', '15%');

                    const dims = Renderer.getDimensions();
                    const pageWidth = dims.pixelWidth > 0 ? dims.pixelWidth : dims.width;
                    const oldWidth = parseFloat($comp.css('width'));
                    const newWidth = pageWidth * 0.7;
                    if (dims.unit === 'in') {
                        $comp.css('width', `${newWidth + 10}px`);
                    } else {
                        $comp.css('width', `${newWidth + 20}px`);
                    }

                    setTimeout(() => {
                        const ratio = newWidth / oldWidth;
                        const size = store.getState().fontSize * ratio;

                        if (dims.unit === 'in') {
                            const pixels = util.getPointsInPixels(size, dims);
                            const percent = util.pixelToPercent(pixels, dims.fontSize);
                            Renderer.updateElementStyle($comp, 'fontSize', `${percent}%`, { fontSize: size });
                        } else {
                            const percent = size * constants.PIXEL_FONT_SIZE_ADJUSTMENT;
                            Renderer.updateElementStyle($comp, 'fontSize', `${percent}%`, { fontSize: size });
                        }
                        store.dispatch(actions.updateElementAttribute('fontSize', size));

                        $comp.css('visibility', 'visible');
                    }, 300)
                } else {
                    $comp.css('width', `${util.pixelToPercent($comp.width() + 5, util.getActiveDimensions().width)}%`);
                    $comp.css('height', `${util.pixelToPercent($comp.height(), util.getActiveDimensions().height)}%`);

                    let x = parseFloat($comp.css('left')) + parseFloat($comp.css('width')) / 2;
                    let y = parseFloat($comp.css('top'));

                    let shapeOverlapColor = findShapeOverlap(x, y);
                    if (shapeOverlapColor !== '') {
                        fontColor = parseInt(shapeOverlapColor, 16) > smartColorThreshold ?
                            darkFont : lightFont;
                    }
                    adjustColor($comp, fontColor);
                }
            })
        } else if (isIllustration || isBackground) {
            const illustrationId = $comp.attr('data-id');
            const $img = $comp.find('img');
            $img.remove();
            designService.getIllustration(illustrationId).then((response) => {
                const illustration = new designDomain.DesignIllustration(response.data);

                const configs = JSON.parse(illustration.configuration);
                const $content = $(illustration.content);
                const $editable = $content.find('[data-custom-color]');

                configs.forEach(() => {
                    $editable.each(function () {
                        const $this = $(this);
                        const attr = $this.attr('data-config');

                        if (attr) {
                            const config = JSON.parse(attr);
                            config.forEach((cfg) => {
                                if (cfg.id === config.id) {
                                    $this.css(config.rule, config.color);
                                }
                            })
                        }
                    })
                });

                const contentHtml = $('<div />').append($content.clone()).html();
                const $svgContent = $('<div class="svg-content"></div>');

                $svgContent.append(contentHtml);

                $comp.append($svgContent);
                $comp.attr('data-configuration', illustration.configuration);
                $comp.find('svg').attr('aria-label', illustration.tags.map(t => t.name).join(', '));
                $comp.css('width', '20%');
                $comp.attr('data-ratio', parseInt(`${$svgContent.width() / $svgContent.height() * 10000}`, 10) / 10000);

                if (isBackground) {
                    $comp.css('width', '100%');
                    $comp.css('height', '100%');
                    $comp.css('top', '0');
                    $comp.css('left', '0');
                }

                store.dispatch(actions.select($comp));
                Renderer.select($comp);
                updatePageBars($comp);
                util.nextTick(() => {
                    Interactable.of($comp).refreshPosition();
                });
            })
        } else if (isQrCode) {
            $comp.css('width', '20%');
            const $img = $comp.find('img');
            $img.css({
                maxWidth: '',
                maxHeight: '',
                width: '100%',
                height: '100%',
            });
            util.nextTick(() => {
                fixQRRatio($comp);
            });
        } else if (isImage) {
            type = 'image';
            const assetId = $comp.attr('data-asset-id');
            const preview = $comp.attr('data-preview');

            let src = assetId ? $comp.find('img').attr('src') : preview;
            if (assetId === 'default') src = false;

            const originalPath = $comp.attr('data-path-original');
            if (originalPath) {
                src = originalPath;
            }

            $comp.find('picture').remove();

            if (src) {
                const $img = $comp.find('img');
                $img.remove();

                const $img2 = $('<img src="" alt="">');
                $img2.attr('src', src);
                $img2.appendTo($comp);

                $img2.css({
                    maxWidth: '',
                    maxHeight: '',
                    width: '100%',
                    height: '100%',
                });
            }

            $comp.css('width', '20%');

            if (isShape) {
                const $svg = $comp.find('svg');
                $svg.attr({
                    width: '100%',
                    height: '100%',
                    preserveAspectRatio: 'none'
                });
                if ($comp.attr('data-shape') === 'line') {
                    $svg.attr({ viewBox: '0 0 95 16', height: '16' });

                    const $line = $svg.find('line');
                    $line.attr({
                        x1: '0', y1: '8', x2: '95', y2: '8'
                    });
                }
                const cWidth = parseInt($svg.attr('width'), 10);
                const cHeight = parseInt($svg.attr('height'), 10);
                $comp.attr('data-ratio', parseInt(`${cWidth / cHeight * 100}`, 10) / 100);
            }
        } else if (isVideoFrame) {
            type = 'video';
            const assetId = $comp.attr('data-asset-id');
            const preview = $comp.attr('data-preview');

            let src = assetId ? $comp.find('video').attr('src') : preview;
            if (assetId === 'default') src = false;

            const originalPath = $comp.attr('data-path-original');
            if (originalPath) {
                src = originalPath;
            }

            $comp.find('picture').remove();

            if (src) {
                const $video = $comp.find('video');
                const altText = $video.parent().attr('aria-label') ? $video.parent().attr('aria-label') : ''
                $video.remove();

                const $video2 = $(`<video controls autoplay loop muted src="" role="img" aria-label="${altText}">`);
                $video2.attr('src', src);
                $video2.appendTo($comp);

                $video2.css({
                    maxWidth: '',
                    maxHeight: '',
                    width: '100%',
                    height: '100%',
                });
            }

            $comp.css('width', '20%');
        } else if (isGroup) {
            $comp.find('.comp').each(function () {
                const $this = $(this);
                $this.addClass('select');
            })
        } else if (isFrame) {
            $comp.find('.meta').remove();
            $comp.css('width', '20%');

            // let isPixabay = ($comp.attr('data-path-original') && $comp.attr('data-path-original').includes('pixabay'));
            // if (isPixabay) {
            //     $comp.find('video').attr('src', $comp.attr('data-path-original'))
            // }

            // Image
            const bgImg = $comp.find('.img').length > 0 ? $comp.find('.img').attr('data-original-bg-img') : false;
            if (bgImg && !bgImg.includes('img-plc')) {
                function loaded() {
                    const pageWidth = util.getActiveDimensions().width;
                    const pageHeight = util.getActiveDimensions().height;
                    const aspectRatio = img.width / img.height;
                    let heightPx = util.percentToPixel(20, pageWidth) / aspectRatio;
                    let heightPercent = util.pixelToPercent(heightPx, pageHeight);
                    $comp.css('height', `${heightPercent}%`);
                    $comp.attr('data-custom-ratio', aspectRatio);
                    updatePageBars($comp);
                    Interactable.of($comp).updateRect();
                }

                let img = new Image;
                img.src = $comp.find('.img').attr('data-original-bg-img');
                $comp.find('.img').css('background', `url("${$comp.find('.img').attr('data-original-bg-img')}") center center / cover`);
                img.onload = loaded;

                const altText = $comp.find('img').attr('alt') ? $comp.find('img').attr('alt') : '';
                $comp.find('picture').remove();

                let isPixabay = ($comp.attr('data-path-original') && $comp.attr('data-path-original').includes('pixabay'));
                if (isPixabay) {
                    let pixabayInfo = JSON.parse($comp.attr('data-pixabay-info'));
                    handlePixabayUpload($comp, pixabayInfo, $comp.attr('data-path-original'), true);
                } else {
                    $comp.find('.img').attr('role', 'img');
                    $comp.find('.img').attr('aria-label', altText);
                }
            }

            // Video
            let bgVideo = $comp.find('.video').length > 0 ? $comp.find('.video').attr('data-original-bg-video') : false;
            if (bgVideo && !bgVideo.includes('video-plc')) {
                function loaded() {
                    const pageWidth = util.getActiveDimensions().width;
                    const pageHeight = util.getActiveDimensions().height;
                    const aspectRatio = video.videoWidth / video.videoHeight;
                    let heightPx = util.percentToPixel(20, pageWidth) / aspectRatio;
                    let heightPercent = util.pixelToPercent(heightPx, pageHeight);
                    $comp.css('height', `${heightPercent}%`);
                    $comp.attr('data-custom-ratio', aspectRatio);
                    // updatePageBars($comp);
                    // Interactable.of($comp).updateRect();
                }

                const video = $comp.find('.video').find('video').get(0);
                let url = $comp.find('.video').attr('data-original-bg-video');
                let altText = $comp.find('.video').attr('aria-label') ? $comp.find('.video').attr('aria-label') : '';
                $comp.find('.video').removeAttr('aria-label');
                $comp.find('.video').removeAttr('role');

                let isPixabay = ($comp.attr('data-path-original') && $comp.attr('data-path-original').includes('player.vimeo'));
                if (isPixabay) {
                    let pixabayInfo = JSON.parse($comp.attr('data-pixabay-info'));
                    let pixabayId = pixabayInfo.id;
                    let ext = $comp.attr('data-path-original').split('.').pop();
                    url = `${constants.SECURE_S3_PATH}public/pixabay-images/${pixabayId}.${ext}`;

                    handlePixabayVideoUpload($comp, pixabayInfo, $comp.attr('data-path-original'), true);
                }

                video.src = url;
                video.controls = false;
                video.muted = false;
                video.autoplay = true;
                video.loop = true;
                video.onmouseover = null;
                video.onmouseout = null;
                video.controlsList = "noplaybackrate nodownload nofullscreen"
                $(video).removeAttr('muted');
                video.role = 'img';
                video.ariaLabel = altText;
                loaded();
                // video.onloadedmetadata = loaded;

                // Loading spinner
                $comp.find('.video').addClass("loading");
                $(video).off("loadedmetadata");
                $(video).on("loadedmetadata", function () {
                    $(video).parent().removeClass('loading');
                });
            }
        }

        if (constants.SCALED_ZOOM_APPROACH) {
            const zoom = store.getState().zoom / 100;
            top = top / zoom;
            left = left / zoom;
        }

        updateElementPercentPosition($comp, top, left);
    }

    if (isFrame) {
        const ratio = $comp.attr('data-ratio');
        if (ratio) {
            setTimeout(() => {
                const dims = util.getActiveDimensions();
                if (ratio === 'full-page') {
                    let width = '100%';
                    let height = '100%';
                    if (dims.unit === 'in') {
                        width = `${util.pixelToPercent(util.inchToPixel(dims.inchWidth), dims.width)}%`;
                        height = `${util.pixelToPercent(util.inchToPixel(dims.inchHeight), dims.height)}%`;
                    }
                    $comp.css({ width, height });
                    $comp.attr('data-ratio', (util.getActiveDimensions().width / util.getActiveDimensions().height));
                    $comp.attr('data-full-page', 'true');
                    $comp.css('top', 'auto');
                    $comp.css('left', 'auto');

                    moveToBack($comp);
                } else {
                    const height = 1 / parseFloat(ratio) * $comp.width();
                    const percentHeight = util.pixelToPercent(height, $comp.parents('.page').height());
                    $comp.css('height', `${percentHeight}%`);
                }
            }, 0);
        }
    } else if (isShape) {
        const ratio = $comp.attr('data-ratio');
        setTimeout(() => {
            const height = 1 / parseFloat(ratio) * $comp.width();
            const percentHeight = util.pixelToPercent(height, $comp.parents('.page').height());
            $comp.css('height', `${percentHeight}%`);
        }, 0)
    } else if (isImage) {
        if (!$comp.attr('data-ratio')) {
            const $img = $comp.find('img');
            if ($img.length > 0) {
                $img.one('load', () => {
                    $comp.attr('data-ratio', parseInt(`${$img.width() / $img.height() * 10000}`, 10) / 10000);
                })
            } else {
                const $svg = $comp.find('.svg-content');
                setTimeout(() => {
                    if ($svg.length > 0) {
                        $comp.attr('data-ratio', parseInt(`${$svg.width() / $svg.height() * 10000}`, 10) / 10000);
                    }
                }, 0)
            }
        }
    }

    function redo() {
        if (isBackground) {
            $parent.children('.content').prepend($comp);
        } else {
            $parent.children('.content').append($comp);
        }

        updateActiveFonts();
        Matrix.add({
            id: componentId,
            type,
            page: $page.attr('id'),
            left: config.position.left,
            top: config.position.top,
            width: $comp.width(),
            height: $comp.height()
        });

        if (store.getState().isTemplate && util.isIllustration($comp)) {
            const illustrationId = $comp.attr('data-id');
            designService.linkIllustration(illustrationId, store.getState().designId);
        }

        util.nextTick(() => {
            Renderer.deselectAll(false);
            store.dispatch(actions.deselect());
            Renderer.select($comp);
            store.dispatch(actions.select($comp));
        })
    }

    function undo() {
        if (store.getState().isTemplate && util.isIllustration($comp)) {
            const illustrationId = $comp.attr('data-id');
            const $illustrations = $('#canvas').find(`[data-id=${illustrationId}]`);
            if ($illustrations.length <= 1) {
                designService.unlinkIllustration(illustrationId, store.getState().designId);
            }
        }

        $comp.remove();
        updateActiveFonts();
        removePageBars();
        Matrix.remove(componentId);
    }

    redo();
    History.push(undo, redo, 'Add element');

    return componentId;
}

export function isElementPartiallyOffPage($element, gutter = 0) {
    let isOff = false;

    const $page = $element.parents('.page');

    const elTop = $element.offset().top;
    const elBottom = elTop + $element.get(0).getBoundingClientRect().height;
    const elLeft = $element.offset().left;
    const elRight = elLeft + $element.get(0).getBoundingClientRect().width;
    // console.log('=> element: ', elTop, elBottom, elLeft, elRight);

    if ($page && $page.offset()) {
        const pageTop = $page.offset().top;
        const pageBottom = pageTop + $page.get(0).getBoundingClientRect().height;
        const pageLeft = $page.offset().left;
        const pageRight = pageLeft + $page.get(0).getBoundingClientRect().width;
        // console.log('=> page: ', pageTop, pageBottom, pageLeft, pageRight);

        if (elTop - gutter < pageTop) {
            isOff = true;
        }

        if (elBottom + gutter > pageBottom) {
            isOff = true;
        }

        if (elLeft - gutter < pageLeft) {
            isOff = true;
        }

        if (elRight + gutter > pageRight) {
            isOff = true;
        }
    }

    return isOff;
}

export function isElementOffPage($element, gutter = 0) {
    let isOff = false;

    const $page = $element.parents('.page');

    const elTop = $element.offset().top;
    const elCR = $element.get(0).getBoundingClientRect();
    const elBottom = elTop + elCR.height;
    const elLeft = $element.offset().left;
    const elRight = elLeft + elCR.width;
    // console.log('=> element: ', elTop, elBottom, elLeft, elRight);

    if ($page && $page.offset()) {
        const pageTop = $page.offset().top;
        const pageCR = $page.get(0).getBoundingClientRect();
        const pageBottom = pageTop + pageCR.height;
        const pageLeft = $page.offset().left;
        const pageRight = pageLeft + pageCR.width;
        // console.log('=> page: ', pageTop, pageBottom, pageLeft, pageRight);

        if (elBottom - gutter < pageTop) {
            isOff = true;
        }

        if (elTop + gutter > pageBottom) {
            isOff = true;
        }

        if (elRight - gutter < pageLeft) {
            isOff = true;
        }

        if (elLeft + gutter > pageRight) {
            isOff = true;
        }
    }

    return isOff;
}

export function getScale($target) {
    return Interactable.of($target).getScale();
}

export function canDisplayAlign($elements) {
    if (!$elements || $elements.length === 0) return false;

    let doRender = true;
    if ($elements.length === 1) {
        const int = Interactable.getIfExists($elements[0]);
        if (int && !int.isGroup && int.isInGroup()) {
            doRender = false;
        }
    }
    return doRender;
}
